import React from 'react'
import {Button, Grid, Typography} from '@material-ui/core/'
import successIconImg from '../../assets/images/success-icon.svg'
import {useSettings} from '../../utils/Settings'

const PasswordChangedSuccessfully = props => {
    const {appConfig} = useSettings()    

    return (
        <Grid item className="login__signin Password_Changed__contanier">
            <Grid item className="login__head">
                <img
                    src={successIconImg}
                    alt="Password Changed Successfully"
                    className="password_success__img"
                />
                <Typography variant="subtitle2" className="password-changed__msg">
                {appConfig.supportedLabels.passwordChange.passwordChangeInfo}
                </Typography>
            </Grid>
            <Grid item xs className="login__form-action">
                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={props.onLoginClick}
                >
                    {appConfig.supportedLabels.passwordChange.loginBtnTxt}
                </Button>
            </Grid>
        </Grid>
    )
}

export default PasswordChangedSuccessfully
